import { updateObject } from '../utility';
import {
    UPDATE_USER_NAME,
    UPDATE_PAGE_NAME,
    UPDATE_ACCOUNT_ID,
    UPDATE_DASHBOARD_URL,
    UPDATE_SIDEBAR_RESOURCE,
    UPDATE_CURRENT_PAGE,
    ENABLE_HEADER_OPERATIONS
} from '../actions/types';

const initialState = {
    accountId: '',
    userName: '',
    pageName: '',
    dashboardUrl: '',
    sidebarResource: {},
    currentPage: '',
    enableHeaderOperation: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_USER_NAME:
            return updateObject(state, { userName: action.payload });
        case UPDATE_PAGE_NAME:
            return updateObject(state, { pageName: action.payload });
        case ENABLE_HEADER_OPERATIONS:
            return { ...state, enableHeaderOperation: true };
        case UPDATE_ACCOUNT_ID:
            return updateObject(state, { accountId: action.payload });
        case UPDATE_DASHBOARD_URL:
            return updateObject(state, { dashboardUrl: action.payload });
        case UPDATE_SIDEBAR_RESOURCE:
            return updateObject(state, { sidebarResource: { ...action.payload } });
        case UPDATE_CURRENT_PAGE:
            return updateObject(state, { currentPage: action.payload });
        default:
            return state;
    }
};
